import { useMemo } from 'react';

import {
  filterMonitoringSchedulesBySearch,
  filterMonitoringSchedulesByType,
} from '../utils/monitoringScheduleUtils';

import type IMonitoringSchedule from 'constants/interfaces/IMonitoringSchedule';

interface IUseMonitoringSchedulesParams {
  schedules: IMonitoringSchedule[],
  sessionType: string,
  search: string,
}

const useMonitoringSchedules = ({
  schedules,
  sessionType,
  search,
}: IUseMonitoringSchedulesParams) => {
  const schedulesForType = useMemo(
    () => filterMonitoringSchedulesByType(schedules, sessionType),
    [schedules, sessionType],
  );

  const filteredSchedules = useMemo(
    () => filterMonitoringSchedulesBySearch(schedulesForType, search),
    [schedulesForType, search],
  );

  return {
    schedulesForType,
    filteredSchedules,
  };
};

export default useMonitoringSchedules;
